// extracted by mini-css-extract-plugin
export var component = "Grid-module--component--7ekue";
export var item = "Grid-module--item--WO2K1";
export var list = "Grid-module--list--PU50B";